import { Flights } from 'models/flights';
import { api } from './client';

export async function getFlights(dashboardId: string): Promise<Flights> {
    const response = await api.get(`/api/dashboards/${dashboardId}/flights`);
    return response.data;
}
